export default __webpack_public_path__ + "static/media/llm.5a7a0a9a.svg";